import { v4 } from "uuid";

export default function generateAppointmentId() {
  return `d-${v4()}`;
}
